<template>
  <div class="modal fade create-new-user-modal" id="CreateCameraModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered ">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Criar camera</h1>
                  <button type="button" class="btn-close create-new-user-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formCreateUser" v-on:submit="createCameraMethod()">
                <div class="modal-body ps-30 pe-30">
                  <p>Preencha as informações abaixo para criar um camera</p>
                  
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="name_camera" class="form-label fw-medium"
                      >Nome da camera</label
                    >
                    <input
                      type="text"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="name_camera"
                      name="name_camera"
                      placeholder="Digite o nome da camera"
                      autocomplete="off"
                      ref="name_camera"
                      required
                    />

                    <label ref="name_camera_alert" class="text-red mb-10 ms-1 d-none-custom fs-16" style="display: none;">Nome é um campo obrigatório</label>
                  </div>

                  <div
                    class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30"
                  >
                    <label for="protocol_option" class="form-label fw-medium">Protocolo:</label>
                    <select v-model="protocol" id="protocol_option" ref="protocol_option" class="form-select shadow-none text-black fs-md-15"
                    >
                      <option selected value="1" class="fw-medium">RTMP</option>
                      <option value="2" class="fw-medium">RTSP</option>
                    </select>
                  </div>

                  <div v-if="protocol == 2" class="mb-70 row">

                    <div
                      class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                    >
                      <label for="ddns_ip_rtsp" class="form-label fw-medium">DDNS ou IP Fixo:</label>
                      <input
                        type="text"
                        class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                        id="ddns_ip_rtsp"
                        name="ddns_ip_rtsp"
                        placeholder="Digite o DDNS ou IP Fixo"
                        autocomplete="off"
                        ref="ddns_ip_rtsp"
                        required
                      />
                    </div>

                    <div
                      class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                    >
                      <label for="port_rtsp" class="form-label fw-medium">Porta RTSP:</label>
                      <input
                        type="text"
                        class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                        id="port_rtsp"
                        name="port_rtsp"
                        placeholder="Digite a porta RTSP"
                        autocomplete="off"
                        ref="port_rtsp"
                        required
                      />
                    </div>

                    <div
                      class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                    >
                      <label for="user_rtsp" class="form-label fw-medium">Usuário:</label>
                      <input
                        type="text"
                        class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                        id="user_rtsp"
                        name="user_rtsp"
                        placeholder="Usuário"
                        autocomplete="off"
                        ref="user_rtsp"
                        required
                      />
                    </div>

                    <div
                      class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                    >
                      <label for="password_rtsp" class="form-label fw-medium">Senha:</label>
                      <input
                        type="password"
                        class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                        id="password_rtsp"
                        name="password_rtsp"
                        placeholder="Senha"
                        autocomplete="off"
                        ref="password_rtsp"
                        required
                      />
                    </div>

                    <div
                      :class="
                        getManufacturers.filter(manu => manu.id == manufacturer)[0].has_channel == 1 &&
                        getManufacturers.filter(manu => manu.id == manufacturer)[0].has_stream == 1 ? 
                        'col-md-4 col-lg-4 col-xl-4 col-xxl-4' : 
                        'col-md-6 col-lg-6 col-xl-6 col-xxl-6'"
                      class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12"
                    >
                      <label for="manufacturer" class="form-label fw-medium">Fabricante:</label>
                      <select v-model="manufacturer" ref="manufacturer" id="manufacturer" class="form-select shadow-none text-black fs-md-16">
                        <option v-for="(value, key) in getManufacturers" :key="key" :selected="key == 0" :value="value.id" class="fw-medium">{{ value.manufacturer }}</option>
                      </select>
                    </div>

                    <div
                      v-if="getManufacturers.filter(manu => manu.id == manufacturer)[0].has_channel == 1"
                      :class="
                        getManufacturers.filter(manu => manu.id == manufacturer)[0].has_channel == 1 &&
                        getManufacturers.filter(manu => manu.id == manufacturer)[0].has_stream == 1 ? 
                        'col-md-4 col-lg-4 col-xl-4 col-xxl-4' : 
                        'col-md-6 col-lg-6 col-xl-6 col-xxl-6'"
                      class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12"
                    >
                      <label for="channel_rtsp" class="form-label fw-medium">Channel:</label>
                      <input
                        type="text"
                        class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                        id="channel_rtsp"
                        name="channel_rtsp"
                        placeholder="Channel"
                        autocomplete="off"
                        ref="channel_rtsp"
                        required
                      />

                      <label ref="channel_rtsp_alert" class="text-red mb-10 ms-1 d-none-custom fs-16" style="display: none;">Channel é um campo obrigatório</label>
                    </div>
                    
                    <div
                      v-if="getManufacturers.filter(manu => manu.id == manufacturer)[0].has_stream == 1"
                      :class="
                        getManufacturers.filter(manu => manu.id == manufacturer)[0].has_channel == 1 &&
                        getManufacturers.filter(manu => manu.id == manufacturer)[0].has_stream == 1 ? 
                        'col-md-4 col-lg-4 col-xl-4 col-xxl-4' : 
                        'col-md-6 col-lg-6 col-xl-6 col-xxl-6'"
                      class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12"
                    >
                      <label for="stream_rtsp" class="form-label fw-medium">Stream:</label>
                      
                      <select 
                        id="stream_rtsp" 
                        name="stream_rtsp"
                        ref="stream_rtsp"
                        class="form-select shadow-none text-black fs-md-15"
                        required
                      >
                        <option selected value="0" class="fw-medium">Principal</option>
                        <option value="1" class="fw-medium">Secundário</option>
                      </select>

                      <label ref="stream_rtsp_alert" class="text-red mb-10 ms-1 d-none-custom fs-16" style="display: none;">Stream é um campo obrigatório</label>
                    </div>

                  </div>

                  <div
                    class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30"
                  >
                    <label for="record_option" class="form-label fw-medium">Armazenar gravação:</label>
                    <select v-model="record" id="record_option" class="form-select shadow-none text-black fs-md-15"
                    >
                      <option selected value="1" class="fw-medium">Sim</option>
                      <option value="0" class="fw-medium">Não</option>
                    </select>
                  </div>

                  <div
                    v-if="record == 1"
                    class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30"
                  >
                    <label for="storage_duration" class="form-label fw-medium">Tempo de armazenamento:</label>
                    <select id="storage_duration" ref="storage_duration" class="form-select shadow-none text-black fs-md-15"
                    >
                      <option value="1" class="fw-medium">1 dia</option>
                      <option value="3" class="fw-medium">3 dias</option>
                      <option value="5" class="fw-medium">5 dias</option>
                      <option value="7" class="fw-medium">7 dias</option>
                      <option value="10" class="fw-medium">10 dias</option>
                      <option value="20" class="fw-medium">20 dias</option>
                      <option value="30" class="fw-medium">30 dias</option>
                      <option value="60" class="fw-medium">60 dias</option>
                      <option value="90" class="fw-medium">90 dias</option>
                      <option value="120" class="fw-medium">120 dias</option>
                    </select>
                  </div>

                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-70">
                    <button type="button" class="btn btn-success fw-bold mb-20" style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;" @click="openPricesModal">
                      <i class="flaticon-search-interface-symbol me-2"></i> Ver tabela de preços
                    </button>
                  </div>

                  <div>
                    <div class="form-check mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                      <input
                        v-model="ai_monitoring_enabled"
                        class="form-check-input"
                        type="checkbox"
                        id="ai_monitoring_enabled"
                      />
                      <label class="form-check-label fw-medium" for="ai_monitoring_enabled">
                        Ativar monitoramento de pessoas/alarme IA
                      </label>
                    </div>

                    <div class="form-check mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                      <input
                        v-model="external_transmission_active"
                        class="form-check-input"
                        type="checkbox"
                        id="external_transmission_active"
                      />
                      <label class="form-check-label fw-medium" for="external_transmission_active">
                        Ativar transmissão externa (SmartSampa)
                      </label>
                    </div>

                    <h5 class="mb-20 fs-16 mt-4">Informe o endereço da camera:</h5>
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl col-xxl-6">
                        <label class="text-black fw-semibold mb-10 fs-16" for="cep">CEP</label>
                        <input
                          class="form-control shadow-none rounded-0 text-black radius-7 custom-font-size"
                          type="text"
                          id="cep"
                          ref="cepField"
                          v-model="form.cep"
                          @input="handleCepInput"
                          maxlength="9"
                          placeholder="Digite o CEP"
                          required
                        />
                        <label ref="cepFieldAlert" class="text-red mb-10 ms-1 d-none-custom fs-16" style="display: none;">O cep é um campo obrigatório</label>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl col-xxl-6">
                        <label class="text-black fw-semibold mb-10 fs-16" for="street">Rua:</label>
                        <input
                          class="form-control shadow-none rounded-0 text-black radius-7 custom-font-size"
                          type="text"
                          id="street"
                          ref="streetField"
                          v-model="form.street"
                          placeholder="Rua"
                          disabled="true"
                        />
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl col-xxl-6 mt-4">
                        <label class="text-black fw-semibold mb-10 fs-16" for="neighborhood">Bairro:</label>
                        <input
                          class="form-control shadow-none rounded-0 text-black radius-7 custom-font-size"
                          type="text"
                          id="neighborhood"
                          ref="neighborhoodField"
                          v-model="form.neighborhood"
                          placeholder="Bairro"
                          disabled="true"
                        />
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl col-xxl-6 mt-4">
                        <label class="text-black fw-semibold mb-10 fs-16" for="city">Cidade:</label>
                        <input
                          class="form-control shadow-none rounded-0 text-black radius-7 custom-font-size"
                          type="text"
                          id="city"
                          ref="cityField"
                          v-model="form.city"
                          placeholder="Cidade"
                          disabled="true"
                        />
                        <label ref="cityFieldAlert" class="text-red mb-10 ms-1 d-none-custom fs-16" style="display: none;">A cidade é um campo obrigatório</label>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl col-xxl-6 mt-4">
                        <label class="text-black fw-semibold mb-10 fs-16" for="state">Estado:</label>
                        <input
                          class="form-control shadow-none rounded-0 text-black radius-7 custom-font-size"
                          type="text"
                          id="state"
                          ref="stateField"
                          v-model="form.state"
                          placeholder="Estado"
                          disabled="true"
                        />
                        <label ref="stateFieldAlert" class="text-red mb-10 ms-1 d-none-custom fs-16" style="display: none;">O estado é um campo obrigatório</label>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl col-xxl-6 mt-4 mb-4">
                        <label class="text-black fw-semibold mb-10 fs-16" for="number">Número:</label>
                        <input
                          class="form-control shadow-none rounded-0 text-black radius-7 custom-font-size"
                          type="text"
                          id="number"
                          ref="numberField"
                          v-model="form.number"
                          placeholder="Número"
                          required
                        />
                        <label ref="numberFieldAlert" class="text-red mb-10 ms-1 d-none-custom fs-16" style="display: none;">O número é um campo obrigatório</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div id="alertResponseApiCreateUser" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageCreateUser">
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="submit" ref="buttonCreateUser" class="btn btn-success">Criar camera</button>
                  <button type="button" class="btn btn-danger create-new-user-modal" data-bs-dismiss="modal">Cancelar</button>
                </div>
              </form>
          </div>
      </div>
  </div>
  <PricesModal />
</template>

<script>

import api from '../../config/axios.js';
import PricesModal from '../Prices/PricesModal.vue';
import * as bootstrap from 'bootstrap';
import { mapGetters } from 'vuex';

export default {
  name: "CreateCameraModal",
  components: {
    PricesModal
  },
  computed: {
    ...mapGetters([
      'getManufacturers'
    ])
  },
  data () {
    return {
      record: 1,
      protocol: 1,
      manufacturer: 1,
      ai_monitoring_enabled: false,
      external_transmission_active: false,
      form: {
        name: '',
        email: '',
        company_id: '',
        cep: "",
        street: "",
        neighborhood: "",
        city: "",
        state: "",
        number: ""
      }
    }
  },
  methods: {
    openPricesModal() {
      // Abrir o modal de preços programaticamente para garantir funcionamento correto
      const pricesModal = new bootstrap.Modal(document.getElementById('PricesModal'));
      pricesModal.show();
    },
    handleCepInput(event) {
      // Remove todos os caracteres não numéricos
      let value = event.target.value.replace(/\D/g, '');
      
      // Aplica a máscara do CEP (00000-000)
      if (value.length > 5) {
        value = value.substring(0, 5) + '-' + value.substring(5, 8);
      }
      
      // Atualiza o valor no input
      event.target.value = value;
      this.form.cep = value;
      
      // Se o CEP tiver 9 caracteres (incluindo o hífen), busca o endereço
      if (value.length === 9) {
        this.fetchAddress();
      }
    },
    async fetchAddress() {
      this.$refs.cepFieldAlert.style.display = "none";
      if (this.form.cep.length !== 9) {
        return;
      }

      this.$refs.cepField.disabled = true;
      this.$refs.numberField.disabled = true;
      this.$refs.buttonCreateUser.disabled = true;
      this.$refs.buttonCreateUser.innerHTML = "Pesquisando Cep...";
      
      try {
        const response = await fetch(`https://viacep.com.br/ws/${this.form.cep.replace(/-/g, "")}/json/`);
        const data = await response.json();
        if (data.erro) {
          this.$refs.streetField.disabled = false;
          this.$refs.neighborhoodField.disabled = false;
          this.$refs.cityField.disabled = false;
          this.$refs.stateField.disabled = false;
          this.$refs.cepField.disabled = false;
          this.$refs.numberField.disabled = false;
          this.$refs.buttonCreateUser.disabled = false;
          this.$refs.buttonCreateUser.innerHTML = "Criar câmera";
          return;
        }
        this.form.street = data.logradouro || "";
        this.form.neighborhood = data.bairro || "";
        this.form.city = data.localidade || "";
        this.form.state = data.uf || "";
        
        this.$refs.streetField.disabled = true;
        this.$refs.neighborhoodField.disabled = true;
        this.$refs.cityField.disabled = true;
        this.$refs.stateField.disabled = true;
        
        this.$refs.numberField.disabled = false;
        this.$refs.cepField.disabled = false;
        this.$refs.buttonCreateUser.disabled = false;
        this.$refs.buttonCreateUser.innerHTML = "Criar câmera";
      } catch (error) {
        alert("Erro ao buscar o CEP. Tente novamente.");
        this.$refs.cepField.disabled = false;
        this.$refs.numberField.disabled = false;
        this.$refs.buttonCreateUser.disabled = false;
        this.$refs.buttonCreateUser.innerHTML = "Criar câmera";
      }
    },
    changeInformationInputs(element){
      this.$refs[element].style.borderColor = "#dedee4";
    },
    createCameraMethod(){
      event.preventDefault();

      const name_camera = this.$refs.name_camera.value;
      const record_option = this.record;

      let error = false;

      var currentManufacturer = undefined;
      
      // Verificação de campos obrigatórios
      if (this.protocol !== undefined && this.protocol == 2) {
        if(this.$refs.ddns_ip_rtsp.value == undefined || this.$refs.ddns_ip_rtsp.value == ""){
          this.$refs.ddns_ip_rtsp_alert.style.display = "block";
          return;
        }

        if(this.$refs.port_rtsp.value == undefined || this.$refs.port_rtsp.value == ""){
          this.$refs.port_rtsp_alert.style.display = "block";
          return;
        }

        if(this.$refs.user_rtsp.value == undefined || this.$refs.user_rtsp.value == ""){
          this.$refs.user_rtsp_alert.style.display = "block";
          return;
        }

        if(this.$refs.password_rtsp.value == undefined || this.$refs.password_rtsp.value == "") {
          this.$refs.password_rtsp_alert.style.display = "block";
          return;
        }

        currentManufacturer = this.getManufacturers.filter(manu => manu.id == this.manufacturer)[0];

        if(currentManufacturer.has_channel == 1){
          if(this.$refs.channel_rtsp.value == undefined || this.$refs.channel_rtsp.value == ""){
            this.$refs.channel_rtsp_alert.style.display = "block";
            return;
          }
        }
        
        if(currentManufacturer.has_stream == 1){
          if(this.$refs.stream_rtsp.value == undefined || this.$refs.stream_rtsp.value == ""){
            this.$refs.stream_rtsp_alert.style.display = "block";
            return;
          }
        }
      }

      if (this.$refs.cpf !== undefined && this.$refs.cpf.value.length != 14) {
        this.$refs.cpfFieldAlert.style.display = "block";
        return;
      }

      if (this.$refs.cepField !== undefined && this.$refs.cepField.value === "") {
        this.$refs.cepFieldAlert.style.display = "block";
        return;
      }

      if (this.$refs.cityField !== undefined && this.$refs.cityField.value === "") {
        this.$refs.cityFieldAlert.style.display = "block";
        return;
      }

      if (this.$refs.stateField !== undefined && this.$refs.stateField.value === "") {
        this.$refs.stateFieldAlert.style.display = "block";
        return;
      }

      if (this.$refs.numberField !== undefined && this.$refs.numberField.value === "") {
        this.$refs.numberFieldAlert.style.display = "block";
        return;
      }

      if(name_camera == ""){
        this.$refs.name_camera_alert.style.display = "block";
        return;
      }
      
      if(record_option == ""){
        this.alertResponse("Por favor preencha a opção de gravação", true);
        return;
      }

      if(name_camera == ""){
        this.$refs.name_camera.style.borderColor = "red";
        error = true;
      }

      if(error){
        return;
      }

      const objCameraCreate= {
        "name": name_camera,
        "installation_id": this.$route.params.installation_id,
        "record": record_option,
        "ai_monitoring_enabled": this.ai_monitoring_enabled,
        "external_transmission_active": this.external_transmission_active,
        "storage_duration": this.$refs.storage_duration != undefined ? this.$refs.storage_duration.value : "0",
        "zip_code": this.$refs.cepField.value,
        "street": this.$refs.streetField.value,
        "number": this.$refs.numberField.value,
        "neighborhood": this.$refs.neighborhoodField.value,
        "city": this.$refs.cityField.value,
        "state": this.$refs.stateField.value,
        "protocol": this.protocol.toString(),
      }

      if (this.protocol == 2) {
        objCameraCreate.ddns_ip_rtsp = this.$refs.ddns_ip_rtsp.value;
        objCameraCreate.port_rtsp = this.$refs.port_rtsp.value;
        objCameraCreate.user_rtsp = this.$refs.user_rtsp.value;
        objCameraCreate.password_rtsp = this.$refs.password_rtsp.value;
        
        if(currentManufacturer != undefined){
          objCameraCreate.manufacturer = currentManufacturer.id;

          if(currentManufacturer.has_channel == 1){
            objCameraCreate.channel_rtsp = this.$refs.channel_rtsp.value;
          }
          
          if(currentManufacturer.has_stream == 1){
            objCameraCreate.stream_rtsp = this.$refs.stream_rtsp.value;
          }
        }
      }

      const buttonCreateUser = this.$refs.buttonCreateUser;
      buttonCreateUser.disabled = true;
      buttonCreateUser.innerHTML = "Criando camera...";
      const alertResponse = this.alertResponse;

        api.axios.post("/api/create/camera", objCameraCreate).catch(function(error){
          if(error.response.data != undefined){
            buttonCreateUser.innerHTML = "Criar camera";
          }
          alertResponse(error.response.data, true);
        }).then(function(response){
          
          if(response != undefined && response.status == 200){
            buttonCreateUser.innerHTML = "Camera criada com sucesso !";
            window.location.reload();
          } else {
            buttonCreateUser.disabled = false;
            buttonCreateUser.innerHTML = "Criar camera";
          }
        });
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageCreateUser").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageCreateUser").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiCreateUser");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 3000);
      }

      const password = document.getElementById("password_user_delete");
      if(password){
        password.value = "";
      }
    },
  }
};
</script>
